
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate3.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Oncology Doctors',
      queryName: 'Oncology',
      teamName: 'Oncology team',
    };
  },
  components: { DoctorsList },
});
